module.exports = __webpack_public_path__ + "assets/img/PrizePool.550fc0b9.png";